module.exports = __webpack_public_path__ + "static/media/icon_dark.409cd71a.svg";